import { render, staticRenderFns } from "./failureTimesPage.vue?vue&type=template&id=353fce98&scoped=true"
import script from "./failureTimesPage.vue?vue&type=script&lang=js"
export * from "./failureTimesPage.vue?vue&type=script&lang=js"
import style0 from "./failureTimesPage.vue?vue&type=style&index=0&id=353fce98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-load_f9e102e5cbb5fa5aa7d45569a28cebe6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353fce98",
  null
  
)

export default component.exports